 
import React   from 'react' ;
 import PageCh24_t1 from './PageCh24_t1';
 import PageCh24_t2 from './PageCh24_t2';
const   PageCh24 = ()=>{
  
   
    return (
      <>  <hr/> 
      <h1 className="m-2" >Chapter24 -Animating React Apps</h1>
        
        <PageCh24_t1 />   
        <PageCh24_t2 />   
      </>
    )
     
} 
export default PageCh24
